var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"illustation-side"},[_c('div',{staticClass:"green-container"},[_c('img',{staticClass:"blob-img",attrs:{"src":require("@/assets/registration/blob.svg")}}),_c('img',{staticClass:"illustration",attrs:{"alt":"illustration","src":_vm.illustrationImg}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }